import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Games admin stack layout
 */
export default function GamesLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[id]" />
      <Stack.Screen name="settings" />
      <Stack.Screen name="memory" />
    </Stack>
  );
}

